import script from "./EditActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditActions.vue?vue&type=script&setup=true&lang=ts"

import "./EditActions.vue?vue&type=style&index=0&id=60b9ffb3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b9ffb3"]])

export default __exports__